import { useSearchParams } from "react-router-dom";
import { isPackagePreview } from "./packagePreview";

/**
 * Preview mode for one package ad, read straight off the URL.
 *
 * Seven package-scoped queries live across the landing page, the detail dialog,
 * its nested room dialog and the mobile search sheet. Threading a flag to all
 * of them would drill props through Header, which knows nothing about packages
 * — and the URL already carries the answer, so each caller asks it directly.
 */
export const usePackagePreview = (packageAdId: string | undefined): boolean => {
  const [searchParams] = useSearchParams();
  return isPackagePreview({
    previewPackageAdId: searchParams.get("previewPackageAdId"),
    openPackageId: packageAdId,
  });
};
